<!--
  SSO bridge: opens the XYLO-ATTENDANCE (Pontaj) admin from an authenticated ERP
  session. We fetch a short-lived hand-off token from the ERP and redirect to the
  Pontaj admin with it in the URL hash; Pontaj exchanges it for its own admin
  session. The router guard guarantees the user is logged in before we get here.
-->
<template>
  <div class="h-screen w-full flex items-center justify-center text-center px-6">
    <div>
      <template v-if="!error">
        <div class="mb-4" style="font-size:2rem">⏳</div>
        <p class="text-lg">Ouverture de XYLO PTJ…</p>
      </template>
      <template v-else>
        <p class="text-lg text-danger mb-4">Impossible d'ouvrir XYLO PTJ.</p>
        <vs-button @click="go">Réessayer</vs-button>
      </template>
    </div>
  </div>
</template>

<script>
import axios from '@/axios.js'

const PONTAJ_ADMIN_URL = 'https://xylo-pontaj.codesinn.com/admin'

export default {
  data () {
    return { error: false }
  },
  methods: {
    go () {
      this.error = false
      axios.get('/auth/attendance-handoff')
        .then((res) => {
          const token = res.data && res.data.token
          if (!token) { this.error = true; return }
          window.location.replace(`${PONTAJ_ADMIN_URL}#sso=${encodeURIComponent(token)}`)
        })
        .catch(() => { this.error = true })
    }
  },
  mounted () {
    this.go()
  }
}
</script>
